import Image from "next/image";
import { useLocale } from "next-intl";
import { THSequence, ENSequence } from "../../assets";

type CreateSequenceProps = {
	onSelectTemplate: (title: string) => void;
};

export default function CreateSequence({ onSelectTemplate }: CreateSequenceProps) {
	const locale = useLocale();
	const sequenceImage = locale === "th" ? THSequence : ENSequence;

	return (
		<div className="w-52 max-w-full px-2 sm:w-56 md:w-[16rem] lg:w-104">
			<button
				type="button"
				onClick={() => onSelectTemplate("Sequence")}
				className="w-full cursor-pointer overflow-hidden rounded-lg"
			>
				<Image
					src={sequenceImage}
					alt="Sequence"
					width={sequenceImage.width}
					height={sequenceImage.height}
					className="h-auto w-full object-contain"
					sizes="(max-width: 639px) 50vw, (max-width: 1023px) 34vw, (max-width: 1200px) 30vw, 480px"
					quality={100}
				/>
			</button>
		</div>
	);
}
